import React from 'react'

interface FlagIconProps extends React.SVGProps<SVGSVGElement> {}
const FlagIcon: React.FC<FlagIconProps> = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='14'
      fill='none'
      {...props}
    >
      <g clipPath='url(#a)'>
        <path
          fill='#FFB800'
          d='m9.834 4.333 1.7-2.266A.667.667 0 0 0 11.001 1H3a.667.667 0 0 0-1.334 0v11.333h-.666a.667.667 0 1 0 0 1.334h2.666a.667.667 0 0 0 0-1.334h-.666V7.667h8a.667.667 0 0 0 .533-1.067l-1.7-2.267Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h12v14H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FlagIcon
